const heroContent = {
  "Infrared" : {
    "title_html" : '<img src="https://cdn.shopify.com/s/files/1/0507/2181/6769/files/magma-white.png?v=1610016799"> <span>Infrared</span>',
    "body" : "Infrared technology heats food directly using an intensely hot stainless-steel plate so your food has no direct exposure to the gas flame. Compared to traditional gas grills, infrared grills produce much higher, intense heat that is evenly distributed on the cooking surface. This uniform heat is ideal for grilling and searing meats as it cooks items quickly and retains the moisture barrier for juicier and more flavorful meat. Since infrared grills only take a few minutes to preheat, you can start grilling sooner saving fuel, time, and energy. Clean up is also quick and easy. When all is said and done, infrared grills are a versatile, convenient, and dependable tool for any BBQ enthusiast.",
    "list_items" : [
      "Intense Even Heat",
      "Eliminates Blow Outs",
      "Reduces Flare-Ups"
    ] 
  },
  "Gift Card" : {
  	"title_html" : '<span>Details</span>',
    "body" : "Can’t decide on the perfect gift? Let them choose with a Magma Gift Card. Simply select the value of the gift card from the dropdown below and add to cart!",
  }
}